import { DOCUMENT }                  from '@angular/platform-browser';
import { Router }                    from '@angular/router';
import { StsTenantService }          from '../../../services/sts-tenant.service';
import { StsPortalStatusService }    from '../../../services/sts-portal-status.service';
import { StsNotification }           from '../../../models/sts-notification.model';
import { StsNotificationType }       from '../../../models/sts-notification-type';
import { StsHttpService }            from '../../../services/sts-http.service';
import { StsPortalStatus }           from '../../../models/sts-portal-status';
import { StsDialogFactoryService }   from 'app/services/sts-dialog-factory.service';
import { StsSessionTimeoutService }  from '../../../services/sts-session-timeout.service';
import { StsButtonComponent }        from 'app/components/common/sts-button/sts-button.component';
import StsLink from '../../../models/sts-link.model';

import {
  Component,
  OnInit,
  Renderer,
  ViewChild,
  Inject,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnDestroy,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'app-account-disclaimer',
  templateUrl: './account-disclaimer.component.html',
  styleUrls: ['./account-disclaimer.component.scss']
})
export class AccountDisclaimerComponent implements OnInit, OnDestroy, AfterViewInit {

  public errors: StsNotification[] = [];
  public disclaimerId: string;
  public showDialog: boolean;
  public dialogueItemUrl: string;
  public isDisclaimerRequired = false;
  public isMemberPortal = true;
  public isLoggedIn = false;
  public disclaimerTextEN: string;
  public disclaimerTextFR: string;
  public formSubmitSuccess = false;
  public isAgreed = false;
  public termsLink: string = null;
  public dialogueItem: StsLink;

  @ViewChild(StsButtonComponent) submitButton;

  @ViewChild('continueBtnRef') continueButton;

  constructor(private tenantService: StsTenantService,
              private router: Router,
              private stsHttp: StsHttpService,
              private portalStatusService: StsPortalStatusService,
              private stsSessionTimeoutService: StsSessionTimeoutService,
              private renderer: Renderer,
              @Inject(DOCUMENT) private document,
              private componentFactoryResolver: ComponentFactoryResolver,
              private viewContainerRef: ViewContainerRef,
              private dialogFactory: StsDialogFactoryService) { }

  ngOnInit() {
    this.stsSessionTimeoutService.setTimeout();
  }

  ngOnDestroy() {
    this.stsSessionTimeoutService.cancelTimeout();
  }

  ngAfterViewInit() {

    this.portalStatusService.getPortalStatus().subscribe((portalStatus: StsPortalStatus) => {

      this.isLoggedIn = portalStatus.isLoggedIn;
      this.isMemberPortal = portalStatus.isMemberPortal;

      this.tenantService.getTenantSource().subscribe(tenant => {
        this.disclaimerId = tenant.disclaimer.id;
        this.isDisclaimerRequired = tenant.isDisclaimerRequired;
        if (!this.isDisclaimerRequired) {
          // console.log('Disclaimer not required, redirecting to home');
          window.location.href = '/';
          return;
        }

        // TODO: need to implement proper i18n code
        this.disclaimerTextEN = tenant.disclaimer.text['en-CA'] || tenant.disclaimer.text['en-US'];
        this.disclaimerTextFR = tenant.disclaimer.text['fr-CA'];

        // TODO: find out if we need to display this disclaimer or if its
        // okay the way we show currently (loading a portal article)
        this.termsLink = '/Article/Print/' + tenant.clientCode.toLocaleLowerCase() + '-terms-of-use';
      });
    });
  }

  bodyLoaded(complete) {
    if (complete) {
      this.dialogFactory.createDialog(this.componentFactoryResolver, this.viewContainerRef, this.document, this.renderer);
    }
  }
  instructionLoaded(complete) {
    if (complete) {
      this.dialogFactory.createDialog(this.componentFactoryResolver, this.viewContainerRef, this.document, this.renderer);
    }
  }

  public getCurrentLink() {
    return this.dialogueItemUrl;
  }

  public click(itemUrl: string): boolean {
    this.dialogueItemUrl = itemUrl;
    this.showDialog = true;
    return false;
  }

  onSave() {
    this.errors = [];
    let requestBody = {
        DisclaimerId: this.disclaimerId
    };
    if (!this.isAgreed) {
      this.userMustAcceptTOU();
      return;
    }
    this.submitButton.onSubmit();
    this.stsHttp.post('/api/users/my/disclaimers', requestBody).subscribe((data) => {
        this.formSubmitSuccess = true;
        this.submitButton.onSubmitFinished();

        let err = new StsNotification();
        err.code = 'sts-disclaimer-success';
        err.level = StsNotificationType.Success;
        err.description = 'Terms of use accepted successfully!';
        this.errors.push(err);
     },
      err => {
        this.formSubmitSuccess = false;
        this.submitButton.onSubmitFinished();

        if (err.error && err.error.errors) {
          for (let i in err.error.errors) {
            let error = new StsNotification();
            error.code = err.error.errors[i].errorCode;
            error.description = err.error.errors[i].explanation || 'Error: ' + err.error.errors[i].errorCode;
            error.level = StsNotificationType.Error;
            this.errors.push(error);
          }
        } else {
          let error = new StsNotification();
          error.code = 'sts-generic-error';
          error.description = 'An error has occurred!';
          error.level = StsNotificationType.Error;
          this.errors.push(error);
        }
      });
  }

  // This is required by the app-sts-bs-dialog component
  onSubmit() {
    return false;
  }

  addProp1(e) {
    this.isAgreed = e.target.checked;
    if (this.isAgreed) {
      this.errors = [];
    }
  }
  onContinue() {
    this.errors = [];
    if (!this.isAgreed) {
      this.userMustAcceptTOU();
      return;
    }

    this.continueButton.onSubmit();
    if (!this.isLoggedIn) {
      window.location.href = '/account/loginFromTool';
    } else {
      window.location.href = '/';
    }
  }

  onCancel() {
      window.location.href = '/';
  }

  userMustAcceptTOU() {
    let error = new StsNotification();
    error.code = 'sts-agree-must-be-clicked';
    error.description = 'You must accept the terms of use before you can continue';
    error.level = StsNotificationType.Error;
    this.errors.push(error);
  }
}
